import React from 'react';
import { useNavigate } from 'react-router-dom';
import { auth } from '../firebase';

export default function BidWonSuccess() {
  const navigate = useNavigate();

  const projectDetails = {
    projectName: 'Skyline Tower Multifamily Construction',
    bidAmount: '$10,074,900',
    completionDate: 'December 2026'
  };

  const handleViewProjectDetails = () => {
    alert('Viewing project details...');
  };

  const handleSocialShare = (platform) => {
    alert(`Sharing on ${platform}...`);
  };

  const handleLogout = () => {
    auth.signOut();
  };

  return (
    <div style={{ 
      minHeight: '100vh', 
      backgroundColor: '#000000', 
      display: 'flex', 
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '2rem'
    }}>
      {/* Main Success Section */}
      <div style={{ 
        textAlign: 'center', 
        marginBottom: '3rem',
        maxWidth: '600px'
      }}>
        {/* Trophy Icon */}
        <div style={{
          width: '120px',
          height: '120px',
          backgroundColor: '#8B5CF6',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 2rem auto'
        }}>
          <svg width="60" height="60" viewBox="0 0 24 24" fill="white">
            <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6" stroke="white" strokeWidth="2" fill="none" />
            <path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18" stroke="white" strokeWidth="2" fill="none" />
            <path d="M4 22h16" stroke="white" strokeWidth="2" fill="none" />
            <path d="M10 14.66V17c0 .55.47.98.97 1.21l1.03.5c.5.23 1.03.23 1.53 0l1.03-.5c.5-.23.97-.66.97-1.21v-2.34" stroke="white" strokeWidth="2" fill="none" />
            <path d="M18 2H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2z" stroke="white" strokeWidth="2" fill="none" />
            <path d="M12 6v6" stroke="white" strokeWidth="2" fill="none" />
            <path d="M9 9l3 3 3-3" stroke="white" strokeWidth="2" fill="none" />
          </svg>
        </div>

        {/* Congratulations Message */}
        <h1 style={{ 
          fontSize: '3rem', 
          fontWeight: 'bold', 
          color: 'white',
          marginBottom: '0.5rem',
          lineHeight: '1.2'
        }}>
          Congratulations!
        </h1>
        
        <h2 style={{ 
          fontSize: '2.5rem', 
          fontWeight: 'bold', 
          color: 'white',
          marginBottom: '1.5rem',
          lineHeight: '1.2'
        }}>
          You Won The Bid
        </h2>

        {/* Project Context */}
        <p style={{ 
          fontSize: '1.25rem', 
          color: 'white',
          marginBottom: '2rem',
          lineHeight: '1.5'
        }}>
          Your project "{projectDetails.projectName}" is now ready to move forward.
        </p>

        {/* View Project Details Button */}
        <button
          onClick={handleViewProjectDetails}
          style={{
            backgroundColor: '#8B5CF6',
            color: 'white',
            padding: '1rem 2rem',
            borderRadius: '12px',
            border: 'none',
            fontSize: '1.125rem',
            fontWeight: '600',
            cursor: 'pointer',
            marginBottom: '2rem',
            transition: 'background-color 0.2s'
          }}
          onMouseOver={(e) => e.target.style.backgroundColor = '#7C3AED'}
          onMouseOut={(e) => e.target.style.backgroundColor = '#8B5CF6'}
        >
          View Project Details
        </button>

        {/* Social Share Buttons */}
        <div style={{ 
          display: 'flex', 
          gap: '1rem', 
          justifyContent: 'center',
          flexWrap: 'wrap'
        }}>
          <button
            onClick={() => handleSocialShare('Facebook')}
            style={{
              backgroundColor: '#E5E7EB',
              color: '#374151',
              padding: '0.75rem 1.5rem',
              borderRadius: '8px',
              border: 'none',
              fontSize: '0.875rem',
              fontWeight: '500',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem'
            }}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="#374151">
              <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
            </svg>
            Share
          </button>

          <button
            onClick={() => handleSocialShare('Twitter')}
            style={{
              backgroundColor: '#E5E7EB',
              color: '#374151',
              padding: '0.75rem 1.5rem',
              borderRadius: '8px',
              border: 'none',
              fontSize: '0.875rem',
              fontWeight: '500',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem'
            }}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="#374151">
              <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/>
            </svg>
            Tweet
          </button>

          <button
            onClick={() => handleSocialShare('LinkedIn')}
            style={{
              backgroundColor: '#E5E7EB',
              color: '#374151',
              padding: '0.75rem 1.5rem',
              borderRadius: '8px',
              border: 'none',
              fontSize: '0.875rem',
              fontWeight: '500',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem'
            }}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="#374151">
              <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
            </svg>
            Share
          </button>
        </div>
      </div>

      {/* Separator Line */}
      <div style={{
        width: '100%',
        height: '1px',
        backgroundColor: '#333',
        marginBottom: '2rem',
        maxWidth: '600px'
      }}></div>

      {/* Bid Details Section */}
      <div style={{ 
        textAlign: 'center',
        maxWidth: '600px',
        width: '100%'
      }}>
        <h3 style={{ 
          fontSize: '1.5rem', 
          fontWeight: 'bold', 
          color: 'white',
          marginBottom: '1.5rem'
        }}>
          Bid Details
        </h3>

        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: '1fr 1fr',
          gap: '1rem',
          textAlign: 'left'
        }}>
          <div>
            <div style={{ color: 'white', fontSize: '0.875rem', marginBottom: '0.5rem' }}>
              Project Name:
            </div>
            <div style={{ color: 'white', fontSize: '0.875rem', marginBottom: '0.5rem' }}>
              Bid Amount:
            </div>
            <div style={{ color: 'white', fontSize: '0.875rem' }}>
              Completion Date:
            </div>
          </div>
          
          <div>
            <div style={{ color: 'white', fontSize: '0.875rem', fontWeight: 'bold', marginBottom: '0.5rem' }}>
              {projectDetails.projectName}
            </div>
            <div style={{ color: 'white', fontSize: '0.875rem', fontWeight: 'bold', marginBottom: '0.5rem' }}>
              {projectDetails.bidAmount}
            </div>
            <div style={{ color: 'white', fontSize: '0.875rem', fontWeight: 'bold' }}>
              {projectDetails.completionDate}
            </div>
          </div>
        </div>
      </div>

      {/* Navigation Button */}
      <div style={{ 
        position: 'absolute', 
        top: '2rem', 
        left: '2rem' 
      }}>
        <button
          onClick={() => navigate('/project-listings')}
          style={{
            backgroundColor: '#2D2D2D',
            color: 'white',
            padding: '0.75rem 1.5rem',
            borderRadius: '8px',
            border: 'none',
            fontSize: '1rem',
            fontWeight: '500',
            cursor: 'pointer'
          }}
        >
          ← Back to Projects
        </button>
      </div>
    </div>
  );
}

